import * as THREE from "three";
import type { TextureLibrary } from "./textures";
import { QUALITY, type QualityPreset } from "../config";

export class Weather {
  rain: THREE.Points;
  splashes: THREE.Points;
  private rainVel: Float32Array;
  private splashLife: Float32Array;
  private count: number;
  private splashCount: number;
  private waterN: THREE.Texture;

  constructor(scene: THREE.Scene, tex: TextureLibrary, quality: QualityPreset) {
    this.count = QUALITY[quality].rain;
    this.splashCount = Math.floor(this.count * 0.25);
    this.waterN = tex.waterN;

    const g = new THREE.BufferGeometry();
    const pos = new Float32Array(this.count * 3);
    this.rainVel = new Float32Array(this.count);
    for (let i = 0; i < this.count; i++) {
      pos[i * 3] = (Math.random() - 0.5) * 70;
      pos[i * 3 + 1] = Math.random() * 24;
      pos[i * 3 + 2] = (Math.random() - 0.5) * 90;
      this.rainVel[i] = 14 + Math.random() * 10;
    }
    g.setAttribute("position", new THREE.BufferAttribute(pos, 3));
    const mat = new THREE.PointsMaterial({
      color: 0xc5d8e6,
      size: 0.14,
      transparent: true,
      opacity: 0.7,
      depthWrite: false,
      map: tex.soft,
      alphaMap: tex.soft,
      sizeAttenuation: true,
    });
    this.rain = new THREE.Points(g, mat);
    this.rain.frustumCulled = false;
    scene.add(this.rain);

    const sg = new THREE.BufferGeometry();
    const sp = new Float32Array(this.splashCount * 3);
    this.splashLife = new Float32Array(this.splashCount);
    sg.setAttribute("position", new THREE.BufferAttribute(sp, 3));
    const sm = new THREE.PointsMaterial({
      color: 0xcfe0ea,
      size: 0.22,
      transparent: true,
      opacity: 0.35,
      depthWrite: false,
      map: tex.soft,
    });
    this.splashes = new THREE.Points(sg, sm);
    this.splashes.frustumCulled = false;
    scene.add(this.splashes);
  }

  update(dt: number, origin: THREE.Vector3) {
    const pos = this.rain.geometry.getAttribute("position") as THREE.BufferAttribute;
    const sp = this.splashes.geometry.getAttribute("position") as THREE.BufferAttribute;
    let si = 0;
    for (let i = 0; i < this.count; i++) {
      let x = pos.getX(i);
      let y = pos.getY(i) - this.rainVel[i] * dt;
      let z = pos.getZ(i) + dt * 2.4;
      if (y < 0.05) {
        if (si < this.splashCount) {
          sp.setXYZ(si, origin.x + x, 0.04, origin.z + z);
          this.splashLife[si] = 0.18;
          si++;
        }
        y = 18 + Math.random() * 6;
        x = (Math.random() - 0.5) * 70;
        z = (Math.random() - 0.5) * 90;
      }
      pos.setXYZ(i, x, y, z);
    }
    pos.needsUpdate = true;
    this.rain.position.set(origin.x, 0, origin.z);

    for (let i = 0; i < this.splashCount; i++) {
      this.splashLife[i] -= dt;
      if (this.splashLife[i] < 0) sp.setY(i, -10);
    }
    sp.needsUpdate = true;

    this.waterN.offset.x += dt * 0.03;
    this.waterN.offset.y += dt * 0.018;
  }
}
